import React, { useEffect } from 'react';

/**
 * 전체화면 지원 여부/상태와 진입 함수를 관리하는 훅.
 * @description
 * - 마운트 시 requestFullscreen 지원 여부를 확인하고 fullscreenchange 리스너를 등록한다.
 * - enterFullScreen으로 루트 엘리먼트 전체화면을 요청한다.
 */
export const useFullscreen = () => {
  /** 브라우저가 전체화면 API(requestFullscreen)를 지원하는지 여부 */
  const [possibleFullScreen, setPossibleFullScreen] = React.useState(false);
  /** 현재 전체화면 상태인지 여부 */
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  useEffect(() => {
    const doc = document.documentElement;
    if (doc.requestFullscreen) setPossibleFullScreen(true);

    const onChange = () => setIsFullScreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  /** 루트 엘리먼트로 전체화면 진입을 요청한다. */
  const enterFullScreen = () => document.documentElement.requestFullscreen();

  return { possibleFullScreen, isFullScreen, enterFullScreen };
};
